import { createContext, useState, useEffect, useMemo } from "react";
import { useQuery } from '@apollo/client';
import { ME_QUERY } from "graphql/APICalls";

export const DataContext = createContext(null);

export default function DataProvider({children}){

  const meQuery = useQuery(ME_QUERY);
  const me = useMemo(() => meQuery.data?.me || {}, [meQuery]);

  const [isInStandaloneMode, setIsInStandaloneMode] = useState(false);

  // Detect standalone / installed PWA mode
  useEffect(()=>{
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true; // iOS fallback

    setIsInStandaloneMode(isStandalone);
  }, []);

  return (
    <DataContext.Provider value={{me, isInStandaloneMode}}>
        {children}
    </DataContext.Provider>
  )
}